import { useContext } from "react";
import { useMutation, useQueryClient } from "react-query";

import * as api from "../../services";
import AppContext from "../../appContext";
import useNotes from "./useNotes";

export default function useSaveNote({ onSuccess }) {
  const queryClient = useQueryClient();
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { notes } = useNotes();
  // replace the current note to the client
  const saveNotes = useMutation(
    ({ action, payload }) => {
      let newNotes = [...notes] ?? [];
      if (action !== "add") {
        const index = newNotes.findIndex(({ id }) => id === payload.id);
        if (index > -1) {
          // item exists
          newNotes.splice(index, 1); // remove item
        }
      }
      if (action !== "delete") newNotes.push(payload);
      const notesJSON = JSON.stringify(newNotes);
      return api.saveNotes({ clientId, notesJSON, projectId, sessionId });
    },
    {
      onSuccess: (data) => {
        if (data.data?.status > 0) {
          onSuccess(data);
          queryClient.invalidateQueries([
            "notes",
            clientId,
            projectId,
            sessionId,
          ]);
        }
      },
    }
  );
  return saveNotes;
}
